export default __webpack_public_path__ + "static/media/mobileWef4.781f4450.png";